import { storage } from '@uhg-abyss/web/tools/storage';
import {
  isSessionValid,
  parseSessionCookie,
} from '../../../../commonUtils/src/sessionManager';

export const FINDCARE_AND_COST_SSO_SESSION_COOKIE: string =
  'FINDCARE_AND_COST_SSO_SESSION';

export { isSessionValid };

export const loginNotRequired = (): boolean => {
  const hostname = window?.location?.hostname?.toLowerCase();
  return hostname === 'localhost';
};

export const isInvalidSession = () => {
  const ssoSessionCookie = storage.cookie.get(
    FINDCARE_AND_COST_SSO_SESSION_COOKIE
  );
  const cookie = parseSessionCookie(ssoSessionCookie);

  if (ssoSessionCookie && !isSessionValid(cookie)) {
    return true;
  }
  return false;
};
